import { render, staticRenderFns } from "./detail-receivers.vue?vue&type=template&id=f2ae6ea0&scoped=true"
import script from "./detail-receivers.vue?vue&type=script&lang=js"
export * from "./detail-receivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae6ea0",
  null
  
)

export default component.exports